import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState, type ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "./AuthProvider";
import { getMfaState, type MfaRoute } from "./mfa";

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const { session, loading } = useAuth();
  const location = useLocation();
  // Garde 2FA (A1) : tant que la decision n'est pas prise, aucune page
  // metier ne s'affiche (pas de flash de contenu en aal1).
  const [mfaRoute, setMfaRoute] = useState<MfaRoute | "loading">("loading");

  useEffect(() => {
    if (!session) {
      setMfaRoute("loading");
      return;
    }
    let cancelled = false;
    setMfaRoute("loading");
    getMfaState()
      .then((state) => {
        if (!cancelled) setMfaRoute(state.route);
      })
      .catch((err) => {
        console.error("[mfa] evaluation failed", err);
        if (!cancelled) setMfaRoute("none");
      });
    return () => {
      cancelled = true;
    };
    // `session` change apres challengeAndVerify : la decision est reevaluee
    // et la route metier s'ouvre.
  }, [session]);

  if (loading || (session && mfaRoute === "loading")) {
    return (
      <div role="status" className="grid min-h-screen place-items-center bg-bg">
        <div
          aria-hidden="true"
          className="size-8 animate-spin rounded-full border-2 border-brand border-t-transparent"
        />
        <span className="sr-only">{t("common.loading")}</span>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (mfaRoute === "challenge") {
    return <Navigate to="/auth/mfa" state={{ from: location }} replace />;
  }
  if (mfaRoute === "enroll") {
    return <Navigate to="/auth/mfa/enrolement" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
